
import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "ActivityCategoryListPage" */
	'pages/sales/Origin/OriginListPage'));

export default [{ component, exact: true, path: '/origins' }];
